// extracted by mini-css-extract-plugin
export default {"container":"Container_container__L8JEO","dark":"Container_dark__FPOvM"};